import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { Store } from '@ngxs/store';
import { AuthState } from '../state/auth.state';
import { SellerState } from '@app/modules/portal/state/seller.state';
import {
  StoreSelectionDialog,
  StoreSelectionDialogData,
  StoreSelectionDialogResult
} from '@app/modules/shared/dialogs/store-selection/store-selection.dialog';
import { MatDialog } from '@angular/material/dialog';
import {SelectedSellerStore, AddSelectedSeller} from '@app/modules/portal/actions/seller.action';
import { SingleSelectionItem } from '@app/modules/shared/components/single-selection-list/single-selection-list.component';
import {
  StoreSearchDialog,
  StoreSearchDialogData,
  StoreSearchDialogResult
} from "@app/modules/shared/dialogs/store-search/store-search.dialog";
import {RoleType} from "@app/modules/portal/models/portal.models";
import { isNullOrUndefined } from 'util';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private store: Store,
    private router: Router,
    private dialog: MatDialog
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    const accessToken = this.store.selectSnapshot(AuthState.token);
    if (accessToken && accessToken.length > 0) {
      const sellerId = this.store.selectSnapshot(SellerState.sellerId);
      const roleType = this.store.selectSnapshot(SellerState.sellerRoles)
      if (!sellerId) {
       if (roleType === 'SU') {
         this.openSellerSearch();
       } else {
          this.openSellerSelection();
       }
      }
      return true;
    } else {
      return this.router.parseUrl('/login');
    }
  }

  private openSellerSearch(){
    this.dialog
      .open<
        StoreSearchDialog,
        StoreSearchDialogData,
        StoreSearchDialogResult
        >(StoreSearchDialog, {
        data: {allowCancel: false},
        width: '480px'
      })
      .afterClosed()
      .subscribe((r?: StoreSearchDialogResult) => {
        if (isNullOrUndefined(r)) {
          return;
        }
        this.store.dispatch([
            new SelectedSellerStore(r.storeId, r.storeName, r.dealerPerorgNo, r.sellerGroupId),
            new AddSelectedSeller(r.storeId, r.storeName, r.dealerPerorgNo, r.sellerGroupId)
          ]
        );

      });
  }

  private openSellerSelection() {
    const sellers = this.store
      .selectSnapshot(SellerState.sellerStores)
      .map(s => {
        return {
          value: s.sellerId,
          label: s.sellerName,
          dealerPerorgNo: s.dealerPerorgNo,
          sellerGroupId: s.sellerGroupId
        };
      });
    if (sellers.length === 1) {
      this.store.dispatch(
        new SelectedSellerStore(
          sellers[0].value,
          sellers[0].label,
          sellers[0].dealerPerorgNo,
          sellers[0].sellerGroupId
        )
      );
    } else {
        const singleSelectableStore: SingleSelectionItem =  {
          selectedValue: sellers.length > 1 ? sellers[0].value : '',
          options: sellers
        };

      this.dialog
        .open<
          StoreSelectionDialog,
          StoreSelectionDialogData,
          StoreSelectionDialogResult
        >(StoreSelectionDialog, {
          data: { singleSelectableStore },
          width: '480px'
        })
        .afterClosed()
        .subscribe((r?: StoreSelectionDialogResult) => {

          if (isNullOrUndefined(r)) {
            return;
          }

          const roles = this.store
            .selectSnapshot(SellerState.sellerStores)
            .find(s => s.sellerId === r.storeId).roles;
          this.store.dispatch(
            new SelectedSellerStore(r.storeId, r.storeName, r.dealerPerorgNo, r.sellerGroupId)
          );
        });
    }
  }
}
